import { WhatsAppAccountDto } from '../../campaign-management/models';

export let isLoadingOption: {
	WA: boolean;
	SMS: boolean;
	LINE: boolean;
	EMAIL: boolean;
	VOICE: boolean;
} = {
	WA: false,
	SMS: false,
	LINE: false,
	EMAIL: false,
	VOICE: false,
};

export let isHaveNextOption: {
	WA: boolean;
	SMS: boolean;
	LINE: boolean;
	EMAIL: boolean;
	VOICE: boolean;
} = {
	WA: true,
	SMS: true,
	LINE: true,
	EMAIL: true,
	VOICE: true,
};

export let pageNoOption: {
	WA: number;
	SMS: number;
	LINE: number;
	EMAIL: number;
	VOICE: number;
} = {
	WA: 1,
	SMS: 1,
	LINE: 1,
	EMAIL: 1,
	VOICE: 1,
};

export let optionList: {
	WA: WhatsAppAccountDto[];
	SMS: WhatsAppAccountDto[];
	LINE: WhatsAppAccountDto[];
	EMAIL: WhatsAppAccountDto[];
	VOICE: WhatsAppAccountDto[];
} = {
	WA: [],
	SMS: [],
	LINE: [],
	EMAIL: [],
	VOICE: [],
};
